/* ═══════════════════════════════════════════
   PETOLOGY — Thème Shopify · JavaScript
   - Menu mobile
   - Nav sticky (ombre au scroll)
   - Sélecteur de quantité
   - Changement de variant (prix + id)
   - Add to cart AJAX (routes.cart_add_url)
   ═══════════════════════════════════════════ */
(function () {
  "use strict";

  /* ---- Menu mobile ---- */
  var burger = document.getElementById("navBurger");
  var mobile = document.getElementById("navMobile");
  if (burger && mobile) {
    burger.addEventListener("click", function () { mobile.classList.toggle("open"); });
    mobile.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () { mobile.classList.remove("open"); });
    });
  }

  /* ---- Nav sticky ombre ---- */
  var nav = document.getElementById("nav");
  if (nav) {
    window.addEventListener("scroll", function () {
      nav.classList.toggle("scrolled", window.scrollY > 30);
    });
  }

  /* ---- Toast ---- */
  function toast(msg) {
    var t = document.createElement("div");
    t.className = "toast";
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("show"); });
    setTimeout(function () {
      t.classList.remove("show");
      setTimeout(function () { t.remove(); }, 400);
    }, 2600);
  }

  /* ---- Mettre à jour le compteur panier ---- */
  function refreshCartCount() {
    fetch(window.routes.cart_url + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ---- Sélecteur de quantité ---- */
  document.querySelectorAll("[data-qty]").forEach(function (input) {
    var row = input.closest(".qty-row");
    if (!row) return;
    var minus = row.querySelector("[data-qty-minus]");
    var plus = row.querySelector("[data-qty-plus]");
    if (minus) minus.addEventListener("click", function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener("click", function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  });

  /* ---- Changement de variant : met à jour prix + id ---- */
  document.querySelectorAll("[data-product-id]").forEach(function (scope) {
    var selects = scope.querySelectorAll("[data-variant-select]");
    if (!selects.length) return;
    var idInput = scope.querySelector("[data-variant-id]");
    var priceEl = scope.querySelector("[data-price]");
    var productId = scope.getAttribute("data-product-id");

    // On récupère les données produit via l'API Shopify (.js)
    var handle = scope.getAttribute("data-product-handle");
    selects.forEach(function (sel) {
      sel.addEventListener("change", function () {
        // Reconstituer le titre du variant choisi
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; }).join(" / ");
        // Charger les données produit pour trouver l'id + prix
        var url = (handle ? "/products/" + handle : window.location.pathname) + ".js";
        fetch(url, { headers: { "Accept": "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (product) {
            var match = product.variants.find(function (v) {
              return v.title === chosen || v.options.join(" / ") === chosen;
            });
            if (match) {
              if (idInput) idInput.value = match.id;
              if (priceEl) priceEl.textContent = formatMoney(match.price);
            }
          })
          .catch(function () {});
      });
    });
  });

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace(".", ",") + " €";
  }

  /* ---- Add to cart AJAX ---- */
  function bindForm(form) {
    form.addEventListener("submit", function (e) {
      // On laisse le bouton "checkout" du panier faire son POST natif
      if (form.querySelector('[name="checkout"]')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : "";
      if (btn) { btn.disabled = true; btn.innerHTML = "Ajout…"; }

      var formData = new FormData(form);
      fetch(window.routes.cart_add_url, {
        method: "POST",
        headers: { "Accept": "application/javascript" },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          refreshCartCount();
          toast("Ajouté au panier 🐾");
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
        })
        .catch(function () {
          // Repli : on redirige vers le panier
          window.location.href = window.routes.cart_url;
        });
    });
  }

  document.querySelectorAll('form[action*="/cart/add"], .featured-form, [data-cart-form]').forEach(bindForm);

})();
